// extracted by mini-css-extract-plugin
module.exports = {"samlLink":"SamlLink_samlLink__3sQCN"};